
        import 'CaptureEmail.b9a52d9.css-module'
        export default {"optIns":"optIns_CaptureEmail_b9a52d9","toggle":"toggle_CaptureEmail_b9a52d9"}
    